import React, { useEffect, useState } from "react";

/** Animated semicircular score gauge 0-100. */
export const ScoreGauge = ({ score = 0, size = 240 }) => {
    const [v, setV] = useState(0);

    useEffect(() => {
        let raf;
        const start = performance.now();
        const dur = 1100;
        const tick = (t) => {
            const p = Math.min(1, (t - start) / dur);
            const eased = 1 - Math.pow(1 - p, 3);
            setV(Math.round(score * eased));
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [score]);

    const r = 90;
    const c = 2 * Math.PI * r;
    const half = c / 2;
    const offset = half - (v / 100) * half;

    return (
        <div className="relative inline-block" style={{ width: size, height: size / 2 + 30 }} data-testid="score-gauge">
            <svg viewBox="0 0 220 130" width={size} height={size * (130 / 220)}>
                <path
                    d={`M 20 110 A ${r} ${r} 0 0 1 200 110`}
                    fill="none"
                    stroke="#E5E5E5"
                    strokeWidth="14"
                    strokeLinecap="round"
                />
                <path
                    d={`M 20 110 A ${r} ${r} 0 0 1 200 110`}
                    fill="none"
                    stroke="#FF5A00"
                    strokeWidth="14"
                    strokeLinecap="round"
                    strokeDasharray={`${half} ${c}`}
                    strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 0.05s linear" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-end pb-1">
                <div className="font-display text-5xl font-black text-ash-black leading-none" data-testid="score-value">
                    {v}
                </div>
                <div className="text-xs uppercase tracking-widest text-ash-gray-dark font-bold mt-1">
                    of 100
                </div>
            </div>
        </div>
    );
};
